<div class="layout">
  <aside class="sidebar">
    <header class="header">
      <a [routerLink]="'/'" class="logo-wrapper">
        <img [src]="logoUrl" alt="stalcraft trade logo" class="logo">
      </a>
    </header>
    <ul class="list">
      <li>
        <a [routerLink]="'/auction/in-game'" [routerLinkActive]="'active'" class="link gtm-menu-link">
          <app-icon name="auction"></app-icon>
          <span> {{ 'menu.auction' | transloco }}</span>
        </a>
      </li>
    </ul>
  </aside>
</div>
